import { useEffect, useRef } from 'react'
import { useLocation } from 'react-router-dom'
import { capturePageview, initPostHog, trackPublicEvent } from '../analytics/posthog'
import { initMetaPixel, trackMetaPageView } from '../analytics/meta-pixel'
import { isTrackablePublicPath, normalizePath } from '../analytics/events'
import { captureAndPersistUtms } from '../analytics/utm'
import { getAnalyticsConsent } from '../analytics/consent'
import { CookieConsentBanner } from './CookieConsentBanner'

const SEO_LANDINGS = new Set([
  '/gold-prediction-trading',
  '/silver-prediction-trading',
  '/prediction-strategies',
  '/how-perfect-predict-works',
  '/mt5-trading-infrastructure',
  '/demo-trading-account',
  '/funding-and-withdrawals',
])

/** Boots PostHog, consent UI, SPA pageviews, and landing-page events. */
export function WebsiteAnalytics() {
  const location = useLocation()
  const lastPath = useRef<string | null>(null)

  useEffect(() => {
    const consent = getAnalyticsConsent()
    if (consent === 'accepted') {
      void initPostHog()
      initMetaPixel()
    }
  }, [])

  useEffect(() => {
    captureAndPersistUtms(location.search)
    const path = normalizePath(location.pathname)
    if (lastPath.current === path) return
    lastPath.current = path

    if (!isTrackablePublicPath(path)) return
    if (getAnalyticsConsent() !== 'accepted') return

    initMetaPixel()
    trackMetaPageView()

    void initPostHog().then((ok) => {
      if (!ok) return
      capturePageview(path)
      if (SEO_LANDINGS.has(path)) {
        trackPublicEvent('seo_landing_page_viewed', {
          page_path: path,
          cta_location: 'landing_page',
        })
      }
      if (path === '/risk-disclosure') {
        trackPublicEvent('risk_disclosure_opened', { page_path: path, cta_location: 'legal' })
      }
    })
  }, [location.pathname, location.search])

  return <CookieConsentBanner />
}
